import React from 'react';
import { arrow } from './styles.module.css';

/**
 * Arrow SVG
 */
export const ArrowRight = ({ className }) => {
  return (
    <svg
      className={[className, arrow].join(' ')}
      viewBox="0 0 18 33"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
    >
      <title>Arrow right</title>
      <path
        d="M14.571 16.692l-1.635-1.635-2.116-2.116-9.766-9.766a1.5 1.5 0 0 1 2.135-2.108l14.129 14.13a1.5 1.5 0 0 1 .384 1.497 1.507 1.507 0 0 1-.384 1.494l-14.13 14.13a1.5 1.5 0 0 1-2.121-2.121l13.504-13.505z"
        fillRule="evenodd"
      />
    </svg>
  );
};

/**
 * Arrow SVG
 */
export const ArrowLeft = ({ className }) => (
  <svg
    className={[className, arrow].join(' ')}
    viewBox="0 0 18 33"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
  >
    <title>Arrow left</title>
    <path
      d="M3.747 16.803l1.635-1.635 2.116-2.116 9.766-9.766a1.5 1.5 0 0 0-2.135-2.108L1 15.308a1.5 1.5 0 0 0-.384 1.497A1.507 1.507 0 0 0 1 18.299l14.13 14.13a1.5 1.5 0 0 0 2.121-2.121L3.747 16.802z"
      fillRule="evenodd"
    />
  </svg>
);
